import { render } from "./ActivitatMaterialUPCommonsView.vue?vue&type=template&id=1ab12632&scoped=true"
import script from "./ActivitatMaterialUPCommonsView.vue?vue&type=script&lang=js"
export * from "./ActivitatMaterialUPCommonsView.vue?vue&type=script&lang=js"

import "./ActivitatMaterialUPCommonsView.vue?vue&type=style&index=0&id=1ab12632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab12632"]])

export default __exports__